import React from 'react';
import { useFitnessWizard } from '../../contexts/FitnessWizardContext';
import { ThemedButton } from '../ThemedButton';
import { Input } from '@/components/ui/input';
import { Label } from '@/components/ui/label';
import { Card, CardContent, CardHeader, CardTitle, CardDescription } from '@/components/ui/card';
import { User } from 'lucide-react';

const FitnessPrimaryContact = () => {
  const { formData, updateFormData, nextStep } = useFitnessWizard();

  const handleSubmit = (e) => {
    e.preventDefault();
    nextStep();
  };

  return (
    <Card className="border-0 shadow-lg">
      <CardHeader className="bg-[#232323] text-white rounded-t-xl">
        <div className="flex items-center gap-3">
          <User className="h-6 w-6" />
          <div>
            <CardTitle className="text-xl">Primary Contact Information</CardTitle>
            <CardDescription className="text-white/60">
              Tell us who we should contact about this application
            </CardDescription>
          </div>
        </div>
      </CardHeader>
      <CardContent className="pt-6">
        <form onSubmit={handleSubmit} className="space-y-6">
          <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
            <div>
              <Label htmlFor="first_name">First Name *</Label>
              <Input
                id="first_name"
                name="first_name"
                data-testid="fitness-first-name-input"
                value={formData.first_name}
                onChange={(e) => updateFormData({ first_name: e.target.value })}
                required
                className="mt-1.5"
                placeholder="John"
              />
            </div>
            <div>
              <Label htmlFor="last_name">Last Name *</Label>
              <Input
                id="last_name"
                name="last_name"
                data-testid="fitness-last-name-input"
                value={formData.last_name}
                onChange={(e) => updateFormData({ last_name: e.target.value })}
                required
                className="mt-1.5"
                placeholder="Smith"
              />
            </div>
          </div>

          <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
            <div>
              <Label htmlFor="applicant_email">Email *</Label>
              <Input
                id="applicant_email"
                name="applicant_email"
                type="email"
                data-testid="fitness-email-input"
                value={formData.applicant_email}
                onChange={(e) => updateFormData({ applicant_email: e.target.value })}
                required
                className="mt-1.5"
                placeholder="john@example.com"
              />
            </div>
            <div>
              <Label htmlFor="applicant_phone">Phone *</Label>
              <Input
                id="applicant_phone"
                name="applicant_phone"
                type="tel"
                data-testid="fitness-phone-input"
                value={formData.applicant_phone}
                onChange={(e) => updateFormData({ applicant_phone: e.target.value })}
                required
                className="mt-1.5"
                placeholder="(555) 123-4567"
              />
            </div>
          </div>

          <div>
            <Label htmlFor="applicant_title">Title/Role (Optional)</Label>
            <Input
              id="applicant_title"
              name="applicant_title"
              data-testid="fitness-title-input"
              value={formData.applicant_title}
              onChange={(e) => updateFormData({ applicant_title: e.target.value })}
              className="mt-1.5"
              placeholder="e.g., Owner, Manager, Director"
            />
          </div>

          <ThemedButton 
            type="submit"
            data-testid="fitness-contact-next-btn"
            variant="wizard" size="full"
          >
            Next: Business Information
          </ThemedButton>
        </form>
      </CardContent>
    </Card>
  );
};

export default FitnessPrimaryContact;
